import React, { SFC } from 'react';
import { getCdnImage } from 'functions';

interface IProps {
  topBanner: string;
}

// tslint:disable-next-line:variable-name
export const Header: SFC<IProps> = (props) => {

  const bannerUrl = getCdnImage(props.topBanner);

  return (
    <section className='banner-header'>
      <div className='header'>
        <img alt='' src={bannerUrl.includes('data:') ? props.topBanner : bannerUrl} />
      </div>
    </section>
  );
};


// WEBPACK FOOTER //
// ./src/components/Cart/Templates/Mobile/Header.tsx